import React, { useEffect, useState } from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { INSTAGRAM, INSTAGRAM_URL } from "../lib/constants";

export default function InstagramPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/instagram")
      .then((r) => setPosts(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="instagram-page" className="py-20">
      <div className="container-page">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="eyebrow mb-3">Instagram</div>
            <h1 className="font-display text-5xl md:text-6xl text-forest-900 leading-[1.05]">
              @{INSTAGRAM}
            </h1>
            <p className="mt-4 text-forest-900/75 max-w-xl">
              Acompanhe o dia a dia da cooperativa, as histórias dos cooperados e os bastidores do manejo florestal direto
              do nosso Instagram oficial.
            </p>
          </div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="instagram-page-follow-cta"
            className="btn-primary self-start md:self-end"
          >
            <Instagram className="w-4 h-4" />
            Seguir no Instagram
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        {loading ? (
          <p className="text-forest-900/60">Carregando publicações...</p>
        ) : posts.length === 0 ? (
          <div className="bg-cream-200 border border-cream-400 p-10 text-center">
            <Instagram className="w-8 h-8 text-forest-700 mx-auto mb-4" />
            <p className="text-forest-900/80 mb-2">Ainda não trouxemos nossas publicações para esta página.</p>
            <p className="text-forest-900/70 text-sm">
              Enquanto isso, siga-nos diretamente em{" "}
              <a href={INSTAGRAM_URL} target="_blank" rel="noreferrer" className="underline text-forest-700 hover:text-copaiba-700">
                @{INSTAGRAM}
              </a>.
            </p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p) => (
              <article key={p.id} data-testid={`instagram-post-${p.shortcode}`} className="bg-white border border-cream-400 overflow-hidden">
                <div className="aspect-square w-full bg-cream-200">
                  <iframe
                    src={`https://www.instagram.com/p/${p.shortcode}/embed/captioned/`}
                    title={`Post Instagram ${p.shortcode}`}
                    loading="lazy"
                    allow="encrypted-media; clipboard-write; web-share"
                    allowFullScreen
                    scrolling="no"
                    className="w-full h-full border-0"
                  />
                </div>
                {p.caption && (
                  <div className="p-5 text-sm text-forest-900/80 leading-relaxed">{p.caption}</div>
                )}
                <a
                  href={p.url}
                  target="_blank"
                  rel="noreferrer"
                  className="border-t border-cream-400 px-5 py-3 flex items-center justify-between text-sm text-forest-700 hover:text-copaiba-700 transition-colors"
                  data-testid={`instagram-post-link-${p.shortcode}`}
                >
                  Ver no Instagram <ArrowUpRight className="w-4 h-4" />
                </a>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
